import React from 'react'
import './working.scss'
const Working = () => {
    return (
        <>
            <section className='workingmainprnt'>
                <div className="custom-container">
                    <div className="workingmainchld">

                        <div className="imgleftworking">
                            <img className='img-fluid' src="\assets\Storageimages\storagefeatureimg.png" alt="" />
                        </div>
 
                        <div className="rightcntworking">
                            <h3>Key Features</h3>
                            <div className="leftcntchldworking">
                                <h5>01. True Privacy </h5>
                                <p>Your data remains yours—encrypted and inaccessible to anyone but you.</p>
                            </div>
                            <div className="leftcntchldworking">
                                <h5>02. Fully Decentralized </h5>
                                <p>Built on a blockchain-powered infrastructure, eliminating single points of failure.</p>
                            </div>
                            <div className="leftcntchldworking">
                                <h5>03. Censorship-Resistant </h5>
                                <p>Designed to protect your data from interference or restrictions.</p>
                            </div>
                            <div className="leftcntchldworking">
                                <h5>04. Seamless Integration </h5>
                                <p>Easily access and manage your files through an intuitive Web3-ready interface.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Working